import Dexie, { type Table } from 'dexie';
import type {
    Pillar,
    Tier,
    Skill,
    SkillProgress,
    Drill,
    Athlete,
    TrainingPreset,
    TrainingSession,
    SessionSkillLink,
    VideoEntry,
    VideoNote,
    Match,
    MatchStats,
    AppSettings,
    Account,
} from '@/types';
import type { OnboardingProfile } from '@/types/onboarding';

export class PalaestraDB extends Dexie {
    pillars!: Table<Pillar, string>;
    tiers!: Table<Tier, string>;
    skills!: Table<Skill, string>;
    skillProgress!: Table<SkillProgress, number>;
    drills!: Table<Drill, string>;
    athletes!: Table<Athlete, string>;
    trainingPresets!: Table<TrainingPreset, string>;
    trainingSessions!: Table<TrainingSession, number>;
    sessionSkillLinks!: Table<SessionSkillLink, number>;
    videoEntries!: Table<VideoEntry, number>;
    videoNotes!: Table<VideoNote, number>;
    matches!: Table<Match, number>;
    matchStats!: Table<MatchStats, number>;
    appSettings!: Table<AppSettings, number>;
    onboardingProfiles!: Table<OnboardingProfile, number>;
    accounts!: Table<Account, number>;

    constructor() {
        super('PalaestraAcademy');

        this.version(1).stores({
            pillars: 'id, order',
            tiers: 'id, pillarId, level',
            skills: 'id, tierId, pillarId, position',
            skillProgress: '++id, athleteId, skillId, [athleteId+skillId]',
            drills: 'id, position',
            athletes: 'id',
            trainingPresets: 'id',
            trainingSessions: '++id, athleteId, startedAt',
            sessionSkillLinks: '++id, sessionId, skillId',
            videoEntries: '++id, athleteId',
            videoNotes: '++id, entryId',
            appSettings: 'id',
        });

        // V2: Onboarding profiles table
        this.version(2).stores({
            onboardingProfiles: '++id, athleteId',
        });

        // V3: Match Intelligence
        this.version(3).stores({
            matches: '++id, athleteId, date, result, eventName, opponentName'
        });

        // V4: Local Accounts & Auth
        this.version(4).stores({
            accounts: '++id, email',
            athletes: 'id, accountId' // Add index for querying by account
        });

        // V5: Match Stats Tracking
        this.version(5).stores({
            matchStats: '++id, matchId'
        });
    }
}

export const db = new PalaestraDB();
